import {
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useContext, useEffect } from "react";
import "./RequestQuote.css";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";
import { ToastContainer, toast } from "react-toastify";
import Header from "../../Shard/Navbar/Header";
import { useNavigate, useParams } from "react-router-dom";
import LoadingAndUnLoading from "./LoadingAndUnLoading";
import ProjectDetails from "./ProjectDetails";
import axios from "axios";
import useFetch from "../../../hooks/useFetch";
import Footer from "../../Shard/Footer/Footer";
import Loader from "../Loader/Loader";
import { AuthContext } from "../../../context/AuthContext";

const useStyles = makeStyles({
  quoteHeading: {
    display: "flex",
    justifyContent: "space-between",
    background: "#DEECFC",
    padding: "10px 20px",
    borderRadius: "10px",
    margin: "10px 0",
  },
  quoteContent: {
    padding: "10px 0px",
    borderRadius: "5px",
  },
  title: {
    paddingBottom: "0px",
  },
  requestQuoteTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: "5px",
  },
  formControl: {
    minWidth: 300,
  },
  selectEmpty: {},
  quoteContainer: {
    display: "flex",
    gap: "20px",
    flexWrap: "wrap",
  },
  requestQuote1Submit: {
    width: "160px",
    height: "45px",
    marginInlineEnd: "10px",
    background: "#BE1E2D",
    color: "#fff",
    marginTop: "20px",
    fontWeight: "600",
  },
});

const RequestQuoteEdit = ({
  isShaw,
  setIsShaw,
  setModalOpen,
  setLoginModalOpen,
  productData,
  vehicleData,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const userId = user?.detail?._id;
  const { id } = useParams();
  const { data, loading } = useFetch(
    `https://abc-backend.onrender.com/api/quotes/${id}`
  );
  const quoteData = data.data;
  const [quoteIntValue, setQuoteIntValue] = React.useState({
    productType: undefined,
    transportationType: undefined,
    packaging: undefined,
    loadDate: undefined,
    vehicleType: undefined,
    deliveryDate: undefined,
  });
  const [productDetailsValue, setProductDetailsValue] = React.useState([]);
  const [loadingUnDetailsValue, setLoadingUnDetailsValue] = React.useState([]);
  const [loadValue, setLoadValue] = React.useState({
    flexibleReadyDate: false,
    flexibleReadyDate1: false,
    flexibleReadyDate2: false,
    flexibleReadyDate3: false,
    flexibleEndDeliveryDate: false,
    flexibleEndDeliveryDate1: false,
    flexibleEndDeliveryDate2: false,
    flexibleEndDeliveryDate3: false,
  });
  const [driverReq, setDriverReq] = React.useState({
    training: false,
    PPE: false,
    entryPermits: false,
  });
  const [associatedServiceValue, setAssociatedServiceValue] = React.useState({
    insuracnce: false,
    certification: false,
    inspectionServices: false,
    customClearance: false,
    associatedEntryPermits: false,
  });
  const [requiredEquipmentValue, setRequiredEquipmentValue] = React.useState({
    liftgate: false,
    palletJack: false,
    loadStraps: false,
    loadbars: false,
    TIRCable: false,
    sideLoading: false,
    pump: false,
    flowMeter: false,
    scullySystem: false,
    lashBelt: false,
    tarpaulin: false,
  });
  const [remarks, setRemarks] = React.useState({
    remarks: undefined,
  });
  // const [validation, setValidation] = useState("");
  const handleChangeQuoteIntValue = (event) => {
    const name = event.target.name;
    setQuoteIntValue({
      ...quoteData.quoteIntValue,
      [name]: event.target.value,
    });
  };
  const handleChangeLoadValue = (event) => {
    const name = event.target.name;
    setLoadValue({
      ...loadValue,
      [name]: event.target.checked,
    });
  };
  const handleChangedriverReq = (event) => {
    const name = event.target.name;
    setDriverReq({
      ...driverReq,
      [name]: event.target.checked,
    });
  };
  const handleChangeAssociatedService = (event) => {
    const name = event.target.name;
    setAssociatedServiceValue({
      ...associatedServiceValue,
      [name]: event.target.checked,
    });
  };
  const handleChangeRequiredEquipment = (event) => {
    const name = event.target.name;
    setRequiredEquipmentValue({
      ...requiredEquipmentValue,
      [name]: event.target.checked,
    });
  };

  const handleChangeRemarks = (event) => {
    const name = event.target.name;
    setRemarks({
      ...quoteData.remarks,
      [name]: event.target.value,
    });
  };

  const handleChangePdValue = (event, i) => {
    const name = event.target.name;
    const value = productDetailsValue;
    const isExist = value.find((item) => {
      return item.serial === i;
    });
    let currentValue = {};
    if (isExist) {
      const index = value.indexOf(isExist);
      currentValue = { ...isExist };
      // const isExistKey = Object.keys(currentValue).find((item) => {
      //   return (currentValue[item] = event.target.value);
      // });
      currentValue[name] = event.target.value;
      // if (isExistKey)
      if (index !== -1) {
        value[index] = currentValue;
      }
    } else {
      currentValue.serial = i;
      currentValue[name] = event.target.value;
      currentValue[name] = event.target.checked;
      value.push(currentValue);
    }
  };

  const handleChangePdLoadingUnloading = (event, i) => {
    const name = event.target.name;
    const value = loadingUnDetailsValue;
    const isExist = value.find((item) => {
      return item.serial === i;
    });
    let currentValue = {};
    if (isExist) {
      const index = value.indexOf(isExist);
      currentValue = { ...isExist };
      currentValue[name] = event.target.value;
      if (index !== -1) {
        value[index] = currentValue;
      }
    } else {
      currentValue.serial = i;
      currentValue[name] = event.target.value;
      value.push(currentValue);
    }
    setLoadingUnDetailsValue(value);
  };

  const notify = () => {
    toast.success("Successfully Added your quote", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const error = (data) => {
    toast.error(data, {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  useEffect(() => {
    if (data) {
      data.data?.quoteIntValue && setQuoteIntValue(data.data.quoteIntValue);
      data.data?.productDetailsValue &&
        setProductDetailsValue(data.data.productDetailsValue);
      data.data?.loadingUnDetailsValue &&
        setLoadingUnDetailsValue(data.data.loadingUnDetailsValue);
      data.data?.loadValue && setLoadValue(data.data.loadValue);
      data.data?.driverReq && setDriverReq(data.data.driverReq);
      data.data?.associatedServiceValue &&
        setAssociatedServiceValue(data.data.associatedServiceValue);
      data.data?.requiredEquipmentValue &&
        setRequiredEquipmentValue(data.data.requiredEquipmentValue);
      data.data?.remarks && setRemarks(data.data.remarks);
    }
  }, [data]);
  let saveDrfat = true;
  let open = true;

  const handleSaveDrfat = async (e) => {
    e.preventDefault();
    let data = {
      quoteIntValue,
      productDetailsValue,
      loadingUnDetailsValue,
      loadValue,
      driverReq,
      associatedServiceValue,
      requiredEquipmentValue,
      remarks,
    };
    try {
      const res = await axios.put(
        `https://abc-backend.onrender.com/api/quotes/${id}`,
        (data = { data, saveDrfat, open, userId })
      );
      if (res.data) {
        notify();
        navigate("/dashboard/my-req");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    saveDrfat = false;
    let data = {
      quoteIntValue,
      productDetailsValue,
      loadingUnDetailsValue,
      loadValue,
      driverReq,
      associatedServiceValue,
      requiredEquipmentValue,
      remarks,
    };
    if (
      Object.values(data.driverReq).find((item) => item === true) &&
      Object.values(data.requiredEquipmentValue).find(
        (item) => item === true
      ) &&
      Object.values(data.associatedServiceValue).find((item) => item === true)
    ) {
      try {
        const res = await axios.put(
          `https://abc-backend.onrender.com/api/quotes/${id}`,
          (data = { data, saveDrfat, open, userId })
        );
        if (res.data) {
          notify();
          navigate("/");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      error(
        "You Can't Empty Associated Service and Required Equipment and Driver Requirements"
      );
    }
  };
  const handleCountDataDelete = (i) => {
    const filterCount = productDetailsValue.filter((_, index) => index !== i);
    setProductDetailsValue(filterCount);
  };
  const handlelUnLCountDelete = (i) => {
    const filterCount = loadingUnDetailsValue.filter((_, index) => index !== i);
    setLoadingUnDetailsValue(filterCount);
  };
  console.log({ productDetailsValue });
  return (
    <div className="Request-a-Quote">
      <Header
        isShaw={isShaw}
        setIsShaw={setIsShaw}
        setLoginModalOpen={setLoginModalOpen}
        setModalOpen={setModalOpen}
      />

      {loading ? (
        <Loader />
      ) : (
        <Container>
          <form
            className="requsetQuote"
            style={{ paddingTop: "95px" }}
            onSubmit={handleSubmit}
          >
            <Box className={classes.quoteHeading}>
              <Box>
                <Typography variant="h6">Request a Quote</Typography>
              </Box>
              <Box>
                <Typography variant="h6">Load Calculater</Typography>
              </Box>
            </Box>
            <Container>
              <div style={{ padding: "30px 0" }}>
                <Box>
                  <Grid container spacing={3}>
                    <Grid item xs={12} lg={4} md={4}>
                      <Box className="quote_inputIcon">
                        <Box>
                          <span>Product Type</span> <br />
                          <Select
                            native
                            required
                            name="productType"
                            onChange={handleChangeQuoteIntValue}
                          >
                            <option
                              aria-label="None"
                              value={quoteData?.quoteIntValue?.productType}
                              defaultValue={
                                quoteData?.quoteIntValue?.productType
                                  ? quoteData?.quoteIntValue?.productType
                                  : ""
                              }
                              selected
                            >
                              {quoteData?.quoteIntValue?.productType}
                            </option>
                            {productData?.map((pdData) => (
                              <option
                                value={pdData.productType}
                                key={pdData._id}
                              >
                                {pdData.productType}
                              </option>
                            ))}
                          </Select>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} lg={4} md={4}>
                      <Box className="quote_inputIcon">
                        <Box>
                          <span>Transportation Type</span> <br />
                          <Select
                            native
                            required
                            name="transportationType"
                            onChange={handleChangeQuoteIntValue}
                            defaultValue={
                              quoteData?.quoteIntValue?.transportationType
                                ? quoteData?.quoteIntValue?.transportationType
                                : ""
                            }
                          >
                            <option
                              aria-label="None"
                              value={
                                quoteData?.quoteIntValue?.transportationType
                              }
                              selected
                            >
                              {quoteData?.quoteIntValue?.transportationType}
                            </option>
                            <option value={"FTL"}>FTL</option>
                            <option value={"LTL"}>LTL</option>
                          </Select>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} lg={4} md={4}>
                      <Box className="quote_inputIcon">
                        <Box>
                          <span className="req_input_label">Packaging</span>{" "}
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            name="packaging"
                            required
                            onChange={handleChangeQuoteIntValue}
                            className="req_input_heading"
                            defaultValue={
                              quoteData?.quoteIntValue?.packaging
                                ? quoteData?.quoteIntValue?.packaging
                                : ""
                            }
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box>
                  <Grid container spacing={3}>
                    <Grid item xs={12} lg={4} md={4}>
                      <Box className="quote_inputIcon">
                        <Box>
                          <span className="req_input_label">Ready to Load</span>
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            name="loadDate"
                            required
                            onChange={handleChangeQuoteIntValue}
                            className="req_input_heading"
                            defaultValue={
                              quoteData?.quoteIntValue?.loadDate
                                ? quoteData?.quoteIntValue?.loadDate
                                : ""
                            }
                            type="date"
                          />
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} lg={4} md={4}>
                      <Box className="quote_inputIcon">
                        <Box>
                          <span>Truck Type</span> <br />
                          <Select
                            native
                            required
                            name="vehicleType"
                            onChange={handleChangeQuoteIntValue}
                          >
                            <option
                              aria-label="None"
                              value={quoteData?.quoteIntValue?.vehicleType}
                              defaultValue={
                                quoteData?.quoteIntValue?.vehicleType
                                  ? quoteData?.quoteIntValue?.vehicleType
                                  : ""
                              }
                              selected
                            >
                              {quoteData?.quoteIntValue?.vehicleType}
                            </option>
                            {vehicleData?.map((vcData) => (
                              <option
                                value={vcData.vehicleType}
                                key={vcData._id}
                              >
                                {vcData.vehicleType}
                              </option>
                            ))}
                          </Select>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} lg={4} md={4}>
                      <Box className="quote_inputIcon bigLabel">
                        <Box>
                          <span className="req_input_label">
                            Estimated Delivery Date
                          </span>
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            name="deliveryDate"
                            required
                            onChange={handleChangeQuoteIntValue}
                            className="req_input_heading"
                            defaultValue={
                              quoteData?.quoteIntValue?.deliveryDate
                                ? quoteData?.quoteIntValue?.deliveryDate
                                : ""
                            }
                            type="date"
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </div>
            </Container>
            {/*Loding and Unloading Details  */}

            <LoadingAndUnLoading
              handleChangePdLoadingUnloading={handleChangePdLoadingUnloading}
              id={id}
              handlelUnLCountDelete={handlelUnLCountDelete}
            />

            {/* Ready to Load */}
            <Box>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={6} md={12}>
                  <Container>
                    <Box className="">
                      <Box>
                        <Box className={classes.title}>
                          <Typography
                            variant="h6"
                            className={classes.requestQuoteTitle}
                          >
                            <span>Ready to Load</span>
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        style={{
                          display: "flex",
                          columnGap: "20px",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <Box className="loadinUnloadingInput">
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            name="loadReady"
                            disabled
                            defaultValue={
                              quoteData?.loadValue?.loadReady
                                ? quoteData?.loadValue?.loadReady
                                : ""
                            }
                            onChange={handleChangeLoadValue}
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={loadValue.flexibleReadyDate}
                                defaultChecked={
                                  quoteData?.loadValue?.flexibleReadyDate
                                    ? quoteData?.loadValue?.flexibleReadyDate
                                    : false
                                }
                                onChange={handleChangeLoadValue}
                                name="flexibleReadyDate"
                                color="primary"
                              />
                            }
                            label="Flexible dates"
                          />
                        </Box>
                      </Box>
                      {loadValue?.flexibleReadyDate && (
                        <Box style={{ display: "flex", gap: "2rem" }}>
                          <Box>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={loadValue.flexibleReadyDate1}
                                  defaultChecked={
                                    quoteData.loadValue.flexibleReadyDate1
                                      ? true
                                      : false
                                  }
                                  onChange={handleChangeLoadValue}
                                  name="flexibleReadyDate1"
                                  color="primary"
                                />
                              }
                              label="1Day"
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={loadValue?.flexibleReadyDate2}
                                  defaultChecked={
                                    quoteData.loadValue.flexibleReadyDate2
                                      ? true
                                      : false
                                  }
                                  onChange={handleChangeLoadValue}
                                  name="flexibleReadyDate2"
                                  color="primary"
                                />
                              }
                              label="2Day"
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={loadValue?.flexibleReadyDate3}
                                  defaultChecked={
                                    quoteData?.loadValue?.flexibleReadyDate3
                                      ? true
                                      : false
                                  }
                                  onChange={handleChangeLoadValue}
                                  name="flexibleReadyDate3"
                                  color="primary"
                                />
                              }
                              label="3Day"
                            />
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Container>
                </Grid>
                <Grid item xs={12} lg={6} md={12}>
                  <Container>
                    <Box className="">
                      <Box>
                        <Box className={classes.title}>
                          <Typography
                            variant="h6"
                            className={classes.requestQuoteTitle}
                          >
                            <span>Expected Delivery Date</span>
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        style={{
                          display: "flex",
                          columnGap: "20px",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <Box className="loadinUnloadingInput">
                          <TextField
                            id="outlined-basic"
                            variant="outlined"
                            disabled
                            name="expectedDeliveryDate"
                            onChange={handleChangeLoadValue}
                            defaultValue={
                              quoteData?.loadValue?.expectedDeliveryDate
                                ? quoteData?.loadValue?.expectedDeliveryDate
                                : ""
                            }
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={loadValue.flexibleEndDeliveryDate}
                                defaultValue={
                                  quoteData?.loadValue?.flexibleEndDeliveryDate
                                    ? quoteData?.loadValue
                                        ?.flexibleEndDeliveryDate
                                    : ""
                                }
                                onChange={handleChangeLoadValue}
                                name="flexibleEndDeliveryDate"
                                color="primary"
                              />
                            }
                            label="Flexible dates"
                          />
                        </Box>
                      </Box>
                      {loadValue?.flexibleEndDeliveryDate && (
                        <Box style={{ display: "flex", gap: "2rem" }}>
                          <Box>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={loadValue?.flexibleEndDeliveryDate1}
                                  defaultValue={
                                    quoteData?.loadValue
                                      ?.flexibleEndDeliveryDate1
                                      ? quoteData?.loadValue
                                          ?.flexibleEndDeliveryDate1
                                      : false
                                  }
                                  onChange={handleChangeLoadValue}
                                  name="flexibleEndDeliveryDate1"
                                  color="primary"
                                />
                              }
                              label="1Day"
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={loadValue?.flexibleEndDeliveryDate2}
                                  defaultValue={
                                    quoteData?.loadValue
                                      ?.flexibleEndDeliveryDate2
                                      ? quoteData?.loadValue
                                          ?.flexibleEndDeliveryDate2
                                      : false
                                  }
                                  onChange={handleChangeLoadValue}
                                  name="flexibleEndDeliveryDate2"
                                  color="primary"
                                />
                              }
                              label="2Day"
                            />
                          </Box>
                          <Box>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={loadValue?.flexibleEndDeliveryDate3}
                                  defaultValue={
                                    quoteData?.loadValue
                                      ?.flexibleEndDeliveryDate3
                                      ? quoteData?.loadValue
                                          ?.flexibleEndDeliveryDate3
                                      : false
                                  }
                                  onChange={handleChangeLoadValue}
                                  name="flexibleEndDeliveryDate3"
                                  color="primary"
                                />
                              }
                              label="3Day"
                            />
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Container>
                </Grid>
              </Grid>
            </Box>

            {/* Driver Requirements */}
            <Box>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={6} md={12}>
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      columnGap: "10px",
                      paddingBottom: "15px",
                    }}
                  >
                    <Typography variant="span">
                      <HomeIcon />
                    </Typography>
                    <Typography variant="h6">Driver Requirements </Typography>
                  </Box>
                  <Container>
                    <Box className="">
                      <Box
                        style={{
                          display: "flex",
                          columnGap: "20px",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={driverReq?.training}
                                onChange={handleChangedriverReq}
                                name="training"
                                defaultChecked={
                                  quoteData?.driverReq?.training ? true : false
                                }
                                color="primary"
                              />
                            }
                            label="Training"
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={driverReq?.PPE}
                                onChange={handleChangedriverReq}
                                name="PPE"
                                color="primary"
                                defaultChecked={
                                  quoteData?.driverReq?.PPE ? true : false
                                }
                              />
                            }
                            label="PPE"
                          />
                        </Box>
                        <Box>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={driverReq?.entryPermits}
                                onChange={handleChangedriverReq}
                                name="entryPermits"
                                color="primary"
                                defaultChecked={
                                  quoteData?.driverReq?.entryPermits
                                    ? true
                                    : false
                                }
                              />
                            }
                            label="Entry Permits"
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Container>
                </Grid>
                <Grid item xs={12} lg={6} md={12}></Grid>
              </Grid>
            </Box>

            {/* Product Details */}
            <ProjectDetails
              handleChangePdValue={handleChangePdValue}
              id={id}
              handleCountDataDelete={handleCountDataDelete}
              productDetailsValue={productDetailsValue}
            />

            {/* Associated Service  */}
            <Box className={classes.quoteContent}>
              <Grid container spacing={1}>
                <Grid item xs={12} lg={12} md={12}>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span className="ServiceIcon">
                            <AllInclusiveIcon />
                          </span>
                          <span> Associated Service</span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="reqCheckBoxMain">
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={associatedServiceValue?.entryPermits}
                              onChange={handleChangeAssociatedService}
                              name="insuracnce"
                              color="primary"
                              defaultChecked={
                                quoteData?.associatedServiceValue.insuracnce
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Insuracnce"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={associatedServiceValue?.certification}
                              onChange={handleChangeAssociatedService}
                              name="certification"
                              color="primary"
                              defaultChecked={
                                quoteData?.associatedServiceValue.certification
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Certification"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                associatedServiceValue?.inspectionServices
                              }
                              onChange={handleChangeAssociatedService}
                              name="inspectionServices"
                              color="primary"
                              defaultChecked={
                                quoteData?.associatedServiceValue
                                  .inspectionServices
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Inspection Services"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={associatedServiceValue?.customClearance}
                              onChange={handleChangeAssociatedService}
                              name="customClearance"
                              color="primary"
                              defaultChecked={
                                quoteData?.associatedServiceValue
                                  .customClearance
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Custom Clearance"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                associatedServiceValue.associatedEntryPermits
                              }
                              onChange={handleChangeAssociatedService}
                              name="associatedEntryPermits"
                              color="primary"
                              defaultChecked={
                                quoteData?.associatedServiceValue
                                  .associatedEntryPermits
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Entry Permits"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              {/* Required Equipment  */}
              <Grid container spacing={1}>
                <Grid item xs={12} lg={12} md={12}>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span className="ServiceIcon">
                            <AllInclusiveIcon />
                          </span>
                          <span> Required Equipment</span>
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="reqCheckBoxMain">
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.liftgate}
                              onChange={handleChangeRequiredEquipment}
                              name="liftgate"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.liftgate
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Liftgate"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.palletJack}
                              onChange={handleChangeRequiredEquipment}
                              name="palletJack"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.palletJack
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="PalletJack"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.loadStraps}
                              onChange={handleChangeRequiredEquipment}
                              name="loadStraps"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.loadStraps
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Load Straps"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.loadBars}
                              onChange={handleChangeRequiredEquipment}
                              name="loadBars"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.loadBars
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Load bars"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.TIRCable}
                              onChange={handleChangeRequiredEquipment}
                              name="TIRCable"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.TIRCable
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="TIR Cable"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.sideLoading}
                              onChange={handleChangeRequiredEquipment}
                              name="sideLoading"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.sideLoading
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Side Loading"
                        />
                      </Box>
                    </Box>
                    <Box className="reqCheckBoxMain">
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.pump}
                              onChange={handleChangeRequiredEquipment}
                              name="pump"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.pump
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Pump"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.flowMeter}
                              onChange={handleChangeRequiredEquipment}
                              name="flowMeter"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.flowMeter
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Flow Meter"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.scullySystem}
                              onChange={handleChangeRequiredEquipment}
                              name="scullySystem"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.scullySystem
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Scully System"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.lashBelt}
                              onChange={handleChangeRequiredEquipment}
                              name="lashBelt"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.lashBelt
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Lash Belt"
                        />
                      </Box>
                      <Box className="ReqcheckBox">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={requiredEquipmentValue.tarpaulin}
                              onChange={handleChangeRequiredEquipment}
                              name="tarpaulin"
                              color="primary"
                              defaultChecked={
                                quoteData?.requiredEquipmentValue.tarpaulin
                                  ? true
                                  : false
                              }
                            />
                          }
                          label="Tarpaulin"
                        />
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              {/* Remarks */}
              <Grid container spacing={1}>
                <Grid item xs={12} lg={8} md={12}>
                  <Box className="">
                    <Box>
                      <Box className={classes.title}>
                        <Typography
                          variant="h6"
                          className={classes.requestQuoteTitle}
                        >
                          <span className="ServiceIcon">
                            <AllInclusiveIcon />
                          </span>
                          <span> Remarks</span>
                        </Typography>
                      </Box>
                      <Box className="request1Input">
                        <input
                          id="outlined-basic"
                          label=""
                          variant="outlined"
                          className="editRequest1Input"
                          name="remarks"
                          required
                          defaultValue={
                            quoteData?.remarks
                              ? quoteData?.remarks?.remarks
                              : ""
                          }
                          onBlur={handleChangeRemarks}
                        />
                      </Box>
                      <Box className="quoteContentBtn">
                        <button
                          className="common-btn common-btn1"
                          onClick={handleSaveDrfat}
                        >
                          Save as Draft
                        </button>
                        <button
                          className="common-btn common-btn2"
                          type="submit"
                        >
                          Submit
                        </button>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </form>
        </Container>
      )}
      <ToastContainer />
      <Footer />
    </div>
  );
};

export default RequestQuoteEdit;
